import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAgentInbox } from '@appic/hooks'
import { showNotification, getPermissionState } from '../../lib/pushNotifications'

export function usePushNotifications(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true
  const navigate = useNavigate()
  const { data: messages } = useAgentInbox(undefined, { enabled })
  const seenIdsRef = useRef<Set<string>>(new Set())
  const initializedRef = useRef(false)

  useEffect(() => {
    if (!enabled || !messages) return
    if (!initializedRef.current) {
      messages.forEach((s) => seenIdsRef.current.add(s.id))
      initializedRef.current = true
      return
    }
    if (getPermissionState() !== 'granted') return

    for (const s of messages) {
      if (seenIdsRef.current.has(s.id)) continue
      seenIdsRef.current.add(s.id)
      if (s.source === 'commander') continue
      if (s.target !== 'commander') continue
      const text = s.payload?.text ?? JSON.stringify(s.payload)
      const room = s.source !== null && s.source !== undefined ? s.source : 'all'
      showNotification({
        title: s.source !== null && s.source !== undefined ? s.source : 'agent',
        body: text.slice(0, 200),
        tag: `agent-${room}`,
        onClick: () => {
          void navigate(`/atc/bridge/agents/chat?room=${encodeURIComponent(room)}`)
        },
      })
    }
  }, [enabled, messages, navigate])
}
